export default __webpack_public_path__ + "static/scrollImage-ac3f7ca3f6d27a4bb1b73da822647009.svg";